import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthStatus, AuthToken } from '@core/auth/auth.model';
import { Observable, ObservableInput, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthBaseService {
  constructor(public httpClient: HttpClient) {}

  redirect(url: string): void {
    window.location.href = url;
  }

  private static handleResponseError(error: any): ObservableInput<AuthStatus> {
    if (error.status === 403) return of({ isAuthenticated: false, token: undefined });
    return throwError(error);
  }

  public logout(): Observable<Object> {
    return this.httpClient.post('/logout', {});
  }

  public refreshToken(): Observable<AuthStatus> {
    return this.httpClient.get<AuthToken>('/api/me').pipe(
      map((response: AuthToken) => {
        return { isAuthenticated: true, token: response };
      }),
      catchError((error) => AuthBaseService.handleResponseError(error))
    );
  }
}
